import React from 'react';
import FeatureTile from '../FeatureTile';
import { useTileData } from '../../../hooks/useTileData';
import { getAimSnapshot } from '../../../api/auth';

const pct1 = (v) => (v == null ? '—' : `${Number(v).toFixed(1)}%`);

const Icon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
  </svg>
);

export default function AiVisibilityTile({ clientId }) {
  // AIM's P1 (AI Knowledge Score) snapshot. Passing null run_id returns the
  // most-recent snapshot, so this doesn't need a run selector.
  const { data, loading, error } = useTileData(
    async () => {
      const resp = await getAimSnapshot(clientId, 'P1', '', null);
      const rows = Array.isArray(resp?.data) ? resp.data : (resp?.data ? [resp.data] : []);
      return rows[0] ?? null;
    },
    [clientId],
    Boolean(clientId),
  );

  const score = data?.value_numeric != null ? Number(data.value_numeric) : null;
  const breakdown = data?.value_breakdown || {};

  const primary = data ? {
    value: score != null ? score.toFixed(1) : '—',
    label: 'AI Knowledge Score',
    subtitle: 'How AI models describe you',
  } : null;
  const secondary = data ? [
    { value: pct1(breakdown.mention_pct), label: 'Visibility' },
    { value: pct1(breakdown.accuracy_pct), label: 'Accuracy' },
  ] : [];

  return (
    <FeatureTile
      title="AI Visibility"
      icon={<Icon />}
      color="purple"
      primary={primary}
      secondary={secondary}
      ctaLabel="Open"
      ctaTo="/ai-visibility"
      loading={loading}
      error={error}
    />
  );
}
